import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { saleProductSelector } from '../../../../../selectors'

import { Input } from '../../../../input'
import { FONTS } from '../../../../../constants'
import { formatNumber } from '../../../../../function/math'

export const license_type = [
  { label: 'MA', value: 'LICENSE_MA' },
  { label: 'License', value: 'LICENSE' },
  { label: 'Subscription', value: 'SUBSCRIPTION' },
]

export const credit_term = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '90', value: '90' },
]

export const InputRow = (props) => {
  const [saleProducts, setSaleProducts] = useState([])
  const _saleProducts = useSelector(saleProductSelector.getSaleProductList)
  const {
    idx,
    license,
    handleInput,
  } = props

  useEffect(() => {
    setSaleProducts(_saleProducts.map(p => {
      return {
        label: p.name,
        value: p._id,
      }
    }))
  }, [_saleProducts])

  const type = license_type.find(t => t.value === license.type)
  const saleProduct = saleProducts.find(p => p.value === license.product_id)
  const creditTerm = credit_term.find(t => t.value === license.credit_term)

  return (
    <Root>
      <Text>{ type ? type.label : '-' }</Text>
      <Text>{ saleProduct ? saleProduct.label : '-' }</Text>
      <InputWrapper>
        <Input
          name='sub_project_code'
          placeholder='Enter Sub-proj. Code'
          value={ license.sub_project_code }
          onChange={ e => handleInput({ license_id: license.license_id, sub_project_code: e.target.value }, 'licenses', idx) }
        />
      </InputWrapper>
      <Text>{ license.description || '-' }</Text>
      <Text>{ license.delivery_date ? moment(license.delivery_date).format('DD/MM/YYYY') : '-' }</Text>
      <Text>{ creditTerm ? creditTerm.label : '-' }</Text>
      <Number>{ formatNumber(license.cost) || '-' }</Number>
      <Number>{ formatNumber(license.price) || '-' }</Number>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 46px;
  display: grid;
  align-items: center;
  grid-gap: 10px;
  grid-template-columns: 3fr 3fr 3fr 4fr 3fr 2fr 3fr 3fr;
  padding: 0 24px;
  background: #FFFFFF;
  margin-top: 1px;

  :nth-child(1) {
    margin: 0;
  }
`

const InputWrapper = styled.div`
  position: relative;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`

const Number = styled(Text)`
  text-align: right;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-licensing/input-row.js